<template>
  <div>
    <!-- ============================================================== -->
    <!-- Page wrapper  -->
    <!-- ============================================================== -->
    <div class="page-wrapper">
      <!-- ============================================================== -->
      <!-- Container fluid  -->
      <!-- ============================================================== -->
      <div class="container-fluid">
        <!-- ============================================================== -->
        <!-- Bread crumb and right sidebar toggle -->
        <!-- ============================================================== -->
        <div class="row page-titles">
          <div class="col-md-5 align-self-center">
            <h4 class="text-themecolor">Advanced Wait Time Reports</h4>
          </div>
          <div class="col-md-7 align-self-center text-right">
            <div class="d-flex justify-content-end align-items-center">
              <ol class="breadcrumb">
                <li class="breadcrumb-item">
                  <a href="/">Home</a>
                </li>
                <li class="breadcrumb-item active">
                  Advanced Wait Time Reports
                </li>
              </ol>
            </div>
          </div>
        </div>

        <div
          class="card text-left"
          style="
            box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.05),
              0 6px 20px 0 rgba(0, 0, 0, 0.04);
          "
        >
          <div class="card-body">
            <div class="row">
              <div class="col-md-6">
                <div class="row">
                  <div class="col-md-12 mb-2">
                    <label class="mdb-main-label">From Stage</label>
                    <select class="form-control">
                      <option value="1">Office Visit</option>
                      <option value="2">MGR</option>
                      <option value="3">Superbill Submitted</option>
                      <option value="4">Payment Received</option>
                      <option value="5">Checkout</option>
                    </select>
                  </div>

                  <div class="col-md-12 mb-2">
                    <label class="mdb-main-label">From Step</label>
                    <select class="form-control">
                      <option value="1">Insurance</option>
                      <option value="2">Demo</option>
                      <option value="3">Pharmacy</option>
                      <option value="4">Payments</option>
                      <option value="5">Vitals</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="row">
                  <div class="col-md-12 mb-2">
                    <label class="mdb-main-label">To Stage</label>
                    <select class="form-control">
                      <option value="1">Office Visit</option>
                      <option value="2">MGR</option>
                      <option value="3">Superbill Submitted</option>
                      <option value="4">Payment Received</option>
                      <option value="5">Checkout</option>
                    </select>
                  </div>

                  <div class="col-md-12 mb-2">
                    <label class="mdb-main-label">To Step</label>
                    <select class="form-control">
                      <option value="1">Insurance</option>
                      <option value="2">Demo</option>
                      <option value="3">Pharmacy</option>
                      <option value="4">Payments</option>
                      <option value="5">Vitals</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="card">
          <table
            id="example23"
            data-height="300"
            class="table display table-bordered table-striped no-wrap"
          >
            <thead class="thead-dark">
              <tr>
                <th>Under 5 Minutes</th>
                <th>Under 5 To 9 Minutes</th>
                <th>Under 10 To 14 Minutes</th>
                <th>Under 15 To 30 Minutes</th>
                <th>Under 30 To 45 Minutes</th>
                <th>Under 45 To 60 Minutes</th>
                <th>Above 60 Minutes</th>
              </tr>
            </thead>

            <tbody>
              <tr v-for="(dt, ndx01) in dt1" :key="ndx01">
                <!-- <td>{{ ndx01 + 1 }}. {{ dt.stepName }}</td> -->
                <td
                  style="text-align: center"
                  v-for="(ts, ndx011) in dt.timeSlot"
                  :key="ndx011"
                >
                  {{ ts }}
                </td>
              </tr>
            </tbody>
          </table>

          <table
            id="clmtable1"
            data-height="300"
            class="table display table-bordered table-striped no-wrap m-t-20"
          >
            <thead class="thead-dark">
              <tr>
                <th>Under 1 hour</th>
                <th>1 To 2 hours</th>
                <th>2 To 4 hours</th>
                <th>4 To 8 hours</th>
                <th>8 To 16 hours</th>
                <th>16 To 24 hours</th>
                <th>24 Plus hours</th>
              </tr>
            </thead>

            <tbody>
              <tr v-for="(dt, ndx02) in aDt2" :key="ndx02">
                <!-- <td>{{ ndx02 + 1 }}. {{ dt.stepName }}</td> -->
                <td
                  style="text-align: center"
                  v-for="(ts, ndx012) in dt.timeSlot"
                  :key="ndx012"
                >
                  {{ ts }}
                </td>
              </tr>
            </tbody>
          </table>

          <table
            id="clmtable2"
            data-height="300"
            class="table display table-bordered table-striped no-wrap m-t-20"
          >
            <thead class="thead-dark">
              <tr>
                <th>Under 1 Day</th>
                <th>1 To 2 days</th>
                <th>2 To 4 days</th>
                <th>4 To 8 days</th>
                <th>8 To 16 days</th>
                <th>16 To 32 days</th>
                <th>32 Plus days</th>
              </tr>
            </thead>

            <tbody>
              <tr v-for="(dt, ndx03) in aDt3" :key="ndx03">
                <!-- <td>{{ ndx03 + 1 }}. {{ dt.stepName }}</td> -->
                <td
                  style="text-align: center"
                  v-for="(ts, ndx013) in dt.timeSlot"
                  :key="ndx013"
                >
                  {{ ts }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- ============================================================== -->
      </div>
      <!-- ============================================================== -->
      <!-- End Container fluid  -->
      <!-- ============================================================== -->
    </div>
    <!-- ============================================================== -->
    <!-- End Page wrapper  -->
    <!-- ============================================================== -->
  </div>
</template>

<script>
import localMixin from "./Mixins/AdvanceWaitTimeReport";
//import moment from "moment";
//import Multiselect from "@vueform/multiselect";
// import Swal from "sweetalert2";

export default {
  name: "AdvanceWaitTimeReport",
  mixins: [localMixin],
  components: {
    //Multiselect,
  },

  data() {
    return {
      dt1: [],
      dt2: [],
      dt3: [],

      aDt1: [
        {
          stageId: 0,
          stepId: 0,
          stepName: "",
        },
      ],

      aDt2: [
        {
          stageId: 0,
          stepId: 0,
          stepName: "",
        },
      ],

      aDt3: [
        {
          stageId: 0,
          stepId: 0,
          stepName: "",
        },
      ],

      stages: [],
      steps: [],

      data99:[],
    };
  }, // data
};
</script>

<style>
</style>